import React, { PureComponent } from 'react';
import _ from 'lodash'
import {
  Card, CardBody, Col, Button, ButtonToolbar, Container, Row, Table,Modal
} from 'reactstrap';
import { Field, reduxForm } from 'redux-form';
import './styles.css';
import EyeIcon from 'mdi-react/EyeIcon';
import EmailIcon from 'mdi-react/EmailIcon';
import AccountSearchIcon from 'mdi-react/AccountSearchIcon';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import renderFileInputField from '../../../../shared/components/form/FileInput';
import renderSelectField from '../../../../shared/components/form/Select';
import renderMultiSelectField from '../../../../shared/components/form/MultiSelect';
import $ from 'jquery';
import readXlsxFile from 'read-excel-file';
import XLSX from 'xlsx';
import { make_cols } from './MakeColumns';
import { SheetJSFT } from './types';
import Sheet from '../../../../images/BIN_MASTER_v1.xlsx';
import Select from 'react-select';
import { MDBDataTable } from 'mdbreact';
import * as FileSaver from 'file-saver';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faDownload, faSyncAlt } from "@fortawesome/free-solid-svg-icons";
import Util from '../../../Common/util';
import API from '../../../Common/api';
import './styles.css';
import LoadingOverlay from 'react-loading-overlay';
import DarkBackground from '../../../Common/backgroundLoader';
import exportToCSV from '../../../Common/exportcsv';
import {addAnalytics, paginationAnalytics} from '../../../Common/analytics';


var url =  window.location.hostname;
var port = window.location.port;
const Heading = [['ID','Client' ,'Product Code',  'Mrp',  ' Product Code',  'Parent Mrp']]


class HorizontalForm extends PureComponent {
  static propTypes = {
    t: PropTypes.func.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    reset: PropTypes.func.isRequired,
  };

  


  constructor() {
   super();

  this.accessCookie = this.accessCookie.bind(this);

   this.fetchBinData = this.fetchBinData.bind(this);
   this.toggle = this.toggle.bind(this);
   this.toggleFailed = this.toggleFailed.bind(this);
   this.processData = this.processData.bind(this);
   this.Successtoggle = this.Successtoggle.bind(this);
   this.ConfirmToggle = this.ConfirmToggle.bind(this);
   this.openConfirm = this.openConfirm.bind(this);

   /*this.onMasterChange = this.onMasterChange.bind(this);*/

    this.state = {
    loading_overlay: false, 
      showPassword: false,
      file: {},
      data: [],
      cols: [],
      dummyFile: {},
      showInvalidItem: false,
      loadingGRNData: false,
      showInvalidBaseItem:false,
      showInvalidProductItem:false,
      fileNameVal: 'masterFile',
      showResponseData: false,
      showRowDataError: false,
      invalidItemList: [],
      selectedOption: null,
      posts: [],
      ErrorRowData: [],
      modal: false,
      modalFailed: false,
      ConfirmModal: false,
      Successmodal: false,
      loading: false,
      isLoading:true,
      showFetchBinData: true,
      showFetchBaseData: false,
      showFetchProductData: false,
      show_process_data: true,
      tableRows: [],
      value: '',
      error: '',
      value: 'select',
      selectedFileType: '',
    

     
       

      


    
    };
  }


  showPassword = (e) => {
    e.preventDefault();
    this.setState(prevState => ({ showPassword: !prevState.showPassword }));
  };

 

  /*onMasterChange(event){
    this.setState({
      value: event.target.value
    })
    console.log(this.state.value);

  }*/

  componentDidMount(){
  this.fetchBinData();
  }


  componentWillMount(){

      if (window.location.port == 8091 || window.location.port === ":8090") {
          port = ":8090"
        }else if (window.location.port == 8098 || window.location.port === ":8098") {
      port = ":8099";
    }else{
          port = ":8088"
        }

      if (url === "localhost") {
        url= "15.206.34.41"+":8090";

      }else{
        url= window.location.hostname+port;
      }

      var cookieUsername = this.getCookie('token');
      var location = this.getCookie('selectedLocation');
      var username = this.accessCookie("token");
      this.setState({
        userName: cookieUsername,
        selectedLocation: location
      })

      localStorage.setItem('userName' , username);
    }






   

  accessCookie(cookieName)
        {
          var name = cookieName + "=";
          var allCookieArray = document.cookie.split(';');
          for(var i=0; i<allCookieArray.length; i++)
          {
            var temp = allCookieArray[i].trim();
            if (temp.indexOf(name)==0)
            return temp.substring(name.length,temp.length);
         }
        return "";
        } 


        getCookie(cname) {
          var name = cname + "=";
          var decodedCookie = decodeURIComponent(document.cookie);
          var ca = decodedCookie.split(';');
          for(var i = 0; i <ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) == ' ') {
              c = c.substring(1);
            }
            if (c.indexOf(name) == 0) {
              return c.substring(name.length, c.length);
            }
          }
          return "";
        }




  

  toggle() {
    this.setState(prevState => ({ modal: !prevState.modal }));
  }

  Successtoggle() {
    this.setState(prevState => ({ Successmodal: !prevState.Successmodal }));
  }

  toggleFailed() {
    this.setState(prevState => ({ modalFailed: !prevState.modalFailed }));  
  }

  ConfirmToggle(){
    this.setState(prevState => ({ ConfirmModal: !prevState.ConfirmModal }));
  }

  openConfirm(){
    this.setState({
      ConfirmModal: true
    })

  }



 

 
  fetchBinData(){


      this.setState({
        showFetchBinData: true,
        showFetchBaseData: false,
        showFetchProductData: false,
        showFetchTesterData: false,
    loading_overlay:true
      })


     const payload={master_type: "alt_product_master",
     location: this.state.selectedLocation,}
API.post('/product/details/v1/', { param: payload })

      .then(response => response.data)

      .then(data => {

         this.setState({posts: data.data,
        filtered_posts : data.data })

      })

      .then(async() => {

         this.setState({ tableRows:this.assemblePosts(), isLoading:false })


      });
  }


  


  assemblePosts= () => {

    let posts =this.state.posts.map((post) => {

      return (

        {
          client: post.client,
          sku: post.sku,

          mrp: post.mrp,
          parent_sku: post.parent_sku,
          parent_mrp: post.parent_mrp,


          

        }

      )

    });

    this.setState({
      loading_overlay: false
    })

    return posts;

  }


  


  processData(){

    this.setState({
      loading: true
    })


    if (this.state.selectedOption.value==="base_pack_zone") {

            

            console.log(this.state.data);
              var arr = []
    
          

          
          for(var i = 0; i < this.state.data.length; i++) {
               // <---- Move declaration inside loop
              
            var orderData  = {};
              orderData['basePackCode'] = this.state.data[i]['BasepackCode'];
              orderData['zoneName'] = this.state.data[i]['ZoneName'];
              orderData['zoneNo'] = this.state.data[i]['ZoneNo'];

              
              arr.push(orderData);
          }

          console.log(arr);
          var arr_data = JSON.stringify(arr)


          const payload = {
            arr_data: this.state.data,
            location: this.state.selectedLocation,
            create: true,
  };

API.post('/inventory/base_pack_zone_code_master/v1/', { param: payload })
            .then((response) =>  {

              console.log(response);
              this.setState({
                showBaseResponseData: true,
                showInvalidBaseItem: false,
                showResponseData: false,
                showInvalidItem: false,
                showProductResponseData: false,
                showTesterResponseData: false,
                showInvalidTesterItem: false,
                showRowDataErrorTester: false,
                showInvalidProductItem: false,
                showRowDataError: false,
                showRowDataErrorBase: false,
                showRowDataErrorProduct: false,
                modal: false,
                modalFailed: false,
                loading: false,
                responseFailBaseData: response.data,
                responseSuccessBaseData: response.data,
                successCreatedMessage: 'BasePack Successfully Created',
                ConfirmModal: false,
                Successmodal: true,


              })

              /*alert("BasePack Successfully Created");*/

              
              /*this.toggleFailed();*/
              this.fetchBaseData();

            })
            .catch(function (error) {
              
              
          });
          }


           if (this.state.selectedOption.value==="tester_basepack_master") {

            

           


          const payload = {
            arr_data: this.state.data,
            location: this.state.selectedLocation,
            create: true,
  };

API.post('/inventory/testerBasePackZoneUtility/v1/', { param: payload })
            .then((response) =>  {

              console.log(response);
              this.setState({
                showBaseResponseData: false,
                showTesterResponseData: true,
                showInvalidBaseItem: false,
                showResponseData: false,
                showRowDataErrorTester: false,
                showInvalidTesterItem: false,
                showInvalidItem: false,
                showProductResponseData: false,
                showInvalidProductItem: false,
                showRowDataError: false,
                showRowDataErrorBase: false,
                showRowDataErrorProduct: false,
                modal: false,
                modalFailed: false,
                loading: false,
                responseFailBaseData: response.data,
                responseSuccessBaseData: response.data,
                successCreatedMessage: 'Tester BasePack Successfully Created',
                ConfirmModal: false,
                Successmodal: true,


              })

              /*alert("BasePack Successfully Created");*/

              
              /*this.toggleFailed();*/
              this.fetchTesterData();

            })
            .catch(function (error) {
              
              
          });
          }



          



          if (this.state.selectedOption.value==="product_master") {




            console.log(this.state.data);
              var arr = []
    
          

          
          for(var i = 0; i < this.state.data.length; i++) {
               // <---- Move declaration inside loop
              
            var orderData  = {};
              orderData['company'] = this.state.data[i]['Company'];
              orderData['brand'] = this.state.data[i]['Brand'];
              orderData['subBrand'] = this.state.data[i]['Sub Brand'];
              orderData['lbSkuId'] = this.state.data[i]['LB SKU ID'];
              orderData['lbSkuProductName'] = this.state.data[i]['LB SKU Product Name'];
              orderData['basepackCode'] = this.state.data[i]['Basepack Code'];
              orderData['cbuCode'] = this.state.data[i]['CBU Code'];
              orderData['shadeCode'] = this.state.data[i]['Shade Code'];
              orderData['shadeName'] = this.state.data[i]['Shade Name'];
              orderData['category'] = this.state.data[i]['Category'];
              orderData['subCategory'] = this.state.data[i]['Sub-Category'];
              orderData['priceLot'] = this.state.data[i]['Price Lot'];
              orderData['mrp'] = this.state.data[i]['MRP'];
              orderData['uom'] = this.state.data[i]['UOM'];
              orderData['upc'] = this.state.data[i]['UPC'];
              orderData['packSize'] = this.state.data[i]['Pack Size'];
              orderData['packSizeUom'] = this.state.data[i]['Pack Size UOM'];
              orderData['ean'] = this.state.data[i]['EAN'];              
              orderData['icldEAN'] = this.state.data[i]['ICLD EAN'];
        
              orderData['weight'] = this.state.data[i]['Weight'];
              orderData['volume'] = this.state.data[i]['Volume'];
              orderData['icldVolume'] = this.state.data[i]['ICLD Volume'];
              orderData['sku7Code'] = this.state.data[i]['SKU7 Code'];
              orderData['sku5Code'] = this.state.data[i]['SKU5 Code'];
              orderData['offer'] = this.state.data[i]['Offer'];
              orderData['tester'] = this.state.data[i]['Tester'];
              orderData['storageType'] = this.state.data[i]['Storage Type'];
              orderData['status'] = this.state.data[i]['Status'];
              orderData['createdDateTime'] = this.state.data[i]['Created Date Time'];
              orderData['updatedDateTime'] = this.state.data[i]['Updated Date Time'];

              
              arr.push(orderData);
          }

          console.log(arr);
          var arr_data = JSON.stringify(arr)


          const payload = {
            arr_data: this.state.data,
            location: this.state.selectedLocation,
            create: true
  };

API.post('/product/product_master/v1/', { param: payload })
            .then((response) =>  {

              console.log(response);
              this.setState({
                showBaseResponseData: false,
                loading: false,
                showProductResponseData: true,
                showTesterResponseData: false,
                showRowDataErrorTester:  false,
                showInvalidTesterItem: false,
                showInvalidBaseItem: false,
                showResponseData: false,
                showInvalidItem: false,
                showInvalidProductItem:false,
                showRowDataError: false,
                showRowDataErrorBase: false,
                showRowDataErrorProduct: false,
                modalFailed: false,
                modal: false,
                responseFailProductData: response.data,
                responseSuccessProductData: response.data,
                successCreatedMessage: 'Product Master Successfully Created',
                ConfirmModal: false,
                Successmodal: true,
                
              })
              /*alert("Product Master Successfully Created");*/
              /*this.toggle();*/
             /* this.toggleFailed();*/
              this.fetchProductData();

            })
            .catch(function (error) {
              
              
          });


              
          }


          if (this.state.selectedOption.value==="bin_master") {
              /*console.log(this.state.BinMasters.length);
              console.log(data.length);*/
            /*if (this.state.BinMasters.length != data.length) {
              alert("Invalid formate");
              let invalidItems = this.state.data.filter(item => !this.validateItem(item))
              console.log(invalidItems);
              return false;
            }*/

            

          var arr = []
    
          

          
          for(var i = 0; i < this.state.data.length; i++) {
               // <---- Move declaration inside loop
              
            var orderData  = {};
              orderData['storageType'] = this.state.data[i]['StorageType'];
              orderData['aisle'] = this.state.data[i]['Aisle'];
              orderData['rack'] = this.state.data[i]['Rack'];
              orderData['rackType'] = this.state.data[i]['RackType'];
              orderData['level'] = this.state.data[i]['Level'];
              orderData['binAddress'] = this.state.data[i]['BIN_ID'];
              orderData['binId'] = this.state.data[i]['Bin'];
              orderData['zoneName'] = this.state.data[i]['ZoneName'];
              orderData['zoneNo'] = this.state.data[i]['ZoneNo'];
              orderData['binVolume'] = 4;

              
              
              arr.push(orderData);
          }

          console.log(arr);
          var arr_data = JSON.stringify(arr)


          const payload = {
            arr_data: this.state.data,
            location: this.state.selectedLocation,
            create: true
  };

API.post('/inventory/bin_master/v1/', { param: payload })
            .then((response) =>  {

              console.log(response);
              
              this.setState({
                showResponseData: true,
                showInvalidItem: false,
                loading: false,
                showBaseResponseData: false,
                showTesterResponseData: false,
                showRowDataErrorTester: false,
                showInvalidTesterItem: false,
                showInvalidBaseItem: false,
                showInvalidProductItem: false,
                showProductResponseData: false,
                showRowDataError: false,
                showRowDataErrorBase: false,
                showRowDataError: false,
                modalFailed: false,
                modal: false,
                responseFailBinData: response.data,
                responseSuccessBinData: response.data,
                successCreatedMessage: 'Bin Master Successfully Created',
                ConfirmModal: false,
                Successmodal: true,

              })
             /* this.toggle();*/
              
              /*this.toggleFailed();*/
              /*alert("Bin Master Successfully Created");*/
              this.fetchBinData();

            })
            .catch(function (error) {
              
              
          });

          }


         /* this.toggleFailed();*/



  }
  filterData = (evt) => {
    if (evt == ""){
      this.setState ({ filtered_posts : this.state.posts})
    }
    else {
    this.setState({
      filtered_posts : []
    })

    // var value = this.state.posts.filter(val => val.client.toLowerCase().includes(evt.toLowerCase()) || val.sku.toLowerCase().includes(evt.toLowerCase()) || val.mrp.toString().includes(evt) || val.parent_mrp.toString().includes(evt) || val.parent_sku.toLowerCase().includes(evt.toLowerCase()))
    var value = this.state.posts.filter(
      (val) =>{
      return Object.keys(val).some(key =>{
        var data = ""
        if (val[key] == null ) {
          data = ""
        } 
        else {
          data = val[key]
        }
        
        return data.toString().toLowerCase().includes(evt.toLowerCase()) 
      })
      }
      );
    this.setState({
        filtered_posts : value
      }) 

   }}


 

  render() {
    const { handleSubmit, reset, t } = this.props;
    const { showPassword } = this.state;
    console.log(this.state.showInvalidItem)
    const { selectedOption } = this.state;
    const { modal } = this.state;
    const { modalFailed } = this.state;
    const { Successmodal } = this.state;
    const { ConfirmModal } = this.state;


    const data = {

      columns: [

        {

          label:'Client',

          field:'client',
          width: 120,
        },

        {

          label:'Product Code',

          field:'sku',
           width: 120,

        },

        {

          label:'Mrp',

          field:'mrp',
           width: 120,

        },

        {

          label:'Parent Product Code ',

          field:'parent_sku',
           width: 150,

        },

         {

          label:'Parent Mrp ',

          field:'parent_mrp',
          width: 140,

        },

        

      ],

      rows:this.state.tableRows,

    }


    return (
      <Col xl={12}>
         {this.state.loading_overlay && (
          <DarkBackground disappear={this.state.loading_overlay}>
           
            <LoadingOverlay
              active={this.state.loading_overlay}
              // spinner={<BounceLoader />}
              spinner={this.state.loading_overlay}
              text={this.state.loadingText}
              style={{ textAlign: "center", alignItem: "center" }}
            >
              {/* <p>Some content or children or something.</p> */}
            </LoadingOverlay>
          </DarkBackground>
        )}
        <Card>
          


          {
            this.state.showFetchBinData  && (

          <CardBody style={{marginTop: 20}}>
            <div className="table_header" style={{borderBottomWidth:'0px'}}>
              
              <h4 style={{fontWeight: 'bold', width: '80%' , paddingTop: 10, float: 'left'}} className="subhead red-text">Alternate Product Master</h4>
              
        <span
                    className="pull-right"
                    onClick={() => exportToCSV(this.state.filtered_posts, "Alernate Prod Master", Heading)}
                    style={{
                      fontSize: "17px",
                      paddingRight: "0px",
                      cursor: "pointer",
                      color: "#919193",
                      paddingTop: "9px",
                    }}
                  >
                    <FontAwesomeIcon icon={faDownload}></FontAwesomeIcon>
                  </span>

            </div>
      <hr style={{marginTop:'30px',marginBottom:'0px'}}/>
            <MDBDataTable
            striped
            bordered
            onSearch={this.filterData}
            sortable={false}
            hover
            data={data}
            onPageChange = {(pageNumber) => paginationAnalytics(pageNumber.activePage,pageNumber.pagesAmount, 'alternate_master_vew', 'datatable_pagination_change' )}
          />
          </CardBody>

          )}

        </Card>
        <Modal
          isOpen={modal}
          toggle={this.toggle}
        >
          <div className="modal__header">
            <button className="lnr lnr-cross modal__close-btn" type="button" style={{right: 15}} onClick={this.toggle} />
            
           
          </div>
          <div className="modal__body" style={{paddingTop: 55, paddingBottom: 20}}>
            <span className="lnr lnr-thumbs-up modal__title-icon" style={{color: '#4ce1b6'}} />
            <h4>Successfully Validated </h4>
          </div>
          <ButtonToolbar className="modal__footer">
            <Button style={{backgroundColor: '#24d6a3', color: '#fff'}} className="modal_ok"  onClick={this.togglePressCancel}>Ok</Button>
          </ButtonToolbar>
        </Modal>


        <Modal
          isOpen={modalFailed}
          toggle={this.toggleFailed}

          style={{maxWidth: 578}}
        >
          <div className="modal__header">
            <button className="lnr lnr-cross modal__close-btn" type="button" style={{right: 15}} onClick={this.toggleFailed} />
            
           
          </div>
          <div className="modal__body" style={{paddingTop: 55, paddingBottom: 20}}>
            <span className="lnr lnr-cross-circle modal__title-icon" style={{color: 'red'}} />
            <h4>This file contains some errors. </h4>
          </div>
          <ButtonToolbar className="modal__footer">
            <Button style={{backgroundColor: '#ddd', color: '#fff'}} className="modal_ok"  onClick={this.togglePressCancel}>Cancel</Button>
            
          </ButtonToolbar>
        </Modal>

        <Modal
          isOpen={Successmodal}
          toggle={this.Successtoggle}
        >
          <div className="modal__header">
            <button className="lnr lnr-cross modal__close-btn" type="button" style={{right: 15}} onClick={this.Successtoggle} />
           
           
          </div>
          <div className="modal__body" style={{paddingTop: 55, paddingBottom: 20}}>
            <span className="lnr lnr-thumbs-up modal__title-icon" style={{color: '#4ce1b6'}} />
            <h4>{this.state.successCreatedMessage}</h4>
          </div>
          <ButtonToolbar className="modal__footer">
            <Button style={{backgroundColor: '#24d6a3', color: '#fff'}} className="modal_ok"  onClick={this.SuccesstoggleCancel}>Ok</Button>
          </ButtonToolbar>
        </Modal>



      </Col>
    );
  }
}

export default reduxForm({
  form: 'Upload Master', // a unique identifier for this form
})(withTranslation('common')(HorizontalForm));